import React, { FC } from 'react';
import cx from 'classnames';
import { Trans } from '@lingui/macro';
import SuperfanIcon from '@/assets/icons/superfan.svg';
import { PropsWithClassName } from '@/types/common';
import Asset from '@/components/Common/Asset';
import AppStore from '@/assets/images/app-store.svg';
import GooglePlay from '@/assets/images/google-play.svg';
import Button from '@/components/Common/Button';
import * as styles from './Superfan.module.scss';

type Props = PropsWithClassName<{
  data: {
    content?: Queries.DatoCmsTextAssetGroupFragment | null;
    qr?: Queries.DatoCmsAssetFragment | null;
    appStoreUrl?: string | null;
    googlePlayUrl?: string | null;
  } | null;
}>;

const Superfan: FC<Props> = ({ className, data }) => {
  const { content, qr, appStoreUrl, googlePlayUrl } = data || {};
  return (
    <div className={cx(styles.main, className)}>
      <div className={styles.text}>
        <SuperfanIcon className={styles.icon} />
        <h3 className={styles.title}>{content?.text?.title}</h3>
        <p>{content?.text?.body}</p>
        <div className={styles.appStoreButtons}>
          <Button
            className={styles.appStoreButton}
            as="a"
            to={appStoreUrl}
            target="_blank"
          >
            <AppStore />
          </Button>
          <Button
            className={styles.appStoreButton}
            as="a"
            to={googlePlayUrl}
            target="_blank"
          >
            <GooglePlay />
          </Button>
        </div>

        <div className={styles.qrLink}>
          <Asset asset={qr} className={styles.qr} />
          <p className={styles.qrText}>
            <Trans>Scan this QR code and download the app</Trans>
          </p>
        </div>
      </div>
      <div className={styles.image}>
        <Asset asset={content?.asset} className={styles.asset} />
      </div>
    </div>
  );
};

export default Superfan;
